import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import { deleteById, Entities, fetchAll, getEntities } from 'src/common/index';

import { fetchTicketEventsJoinFetchTickets } from 'src/actions/event-tickets';
import TicketEventAdministration from 'src/components/admin/event-tickets/events/ticket-event-administration';

const mapStateToProps = state => {
    return {
        ticketEvents: getEntities(state, Entities.TICKET_EVENT),
        eventCategories: getEntities(state, Entities.TICKET_EVENT_CATEGORY),
    };
};

const TicketEventAdministrationContainer = connect(mapStateToProps, {
    fetchAll,
    deleteById,
    fetchTicketEventsJoinFetchTickets,
    push,
})(TicketEventAdministration);

export default TicketEventAdministrationContainer;
